import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API_BASE });

client.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("flow_token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
});

client.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response?.status === 401) {
            localStorage.removeItem("flow_token");
            localStorage.removeItem("flow_user");
            if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/signup")) {
                window.location.href = "/login";
            }
        }
        return Promise.reject(err);
    }
);

export default client;
